import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  title?: string;
}
export const MainLayout: FC<Props> = ({ children, title }) => {
  return (
    <div className="w-full h-full flex flex-col p-6 gap-6 min-h-screen">
      <div className="flex flex-row justify-between">
        {title && <h1 className="text-2xl semi-bold">{title}</h1>}
      </div>
      {children}
    </div>
  );
};
